import { blogApi } from '.';

// Bu dosya API generator tarafından üretilmez — güvenle düzenlenebilir.
export const blogApiWithTags = blogApi.enhanceEndpoints({
  endpoints: {
    // ---- Announcements (Kullanıcı) ----
    getFeaturedAnnouncementsAsync: { providesTags: ['Announcements'] },
    getAnnouncementListAsync: { providesTags: ['Announcements'] },
    getAnnouncements: { providesTags: ['Announcements'] },
    getAnnouncementAsync: { providesTags: ['Announcements'] },

    // ---- Blogs (Kullanıcı) ----
    getBlogsAsync: { providesTags: ['Blogs'] },
    getBlogsByCategoryAsync: { providesTags: ['Blogs'] },
    getHighlightedHomeBlogsAsync: { providesTags: ['Blogs'] },
    getHighlightedByCategoryAsync: { providesTags: ['Blogs'] },
    getBlogAsync: { providesTags: ['Blogs'] },
    // Backoffice endpoints:
    getAllBlogs: { providesTags: ['Blogs'] },
    getBlogById: { providesTags: ['Blogs'] },

    // ---- Blog Categories ----
    getCategoriesByTypeAsync: { providesTags: ['BlogCategories'] },
    getCategoryAsync: { providesTags: ['BlogCategories'] },

    // ---- Favorite Blogs ----
    getUserFavoriteBlogsAsync: { providesTags: ['FavoriteBlogs'] },
    createFavoriteBlogAsync: {
      invalidatesTags: ['FavoriteBlogs', 'Blogs'],
    },
    deleteFavoriteBlogAsync: {
      invalidatesTags: ['FavoriteBlogs', 'Blogs'],
    },

    // ---- FAQs ----
    getFeaturedFaqsAsync: { providesTags: ['Faqs'] },
    getFaqAsync: { providesTags: ['Faqs'] },
    getFaqsByCategoryAsync: { providesTags: ['Faqs'] },
    getFaqsAsync: { providesTags: ['Faqs'] },

    // ---- FAQ Categories ----
    getFaqCategoriesAsync: { providesTags: ['FaqCategories'] },
    getFaqCategoryAsync: { providesTags: ['FaqCategories'] },
  },
});
